/**
 * Sign-in page mutations, called before anyone is authenticated (the Relay
 * environment sends no Authorization header without a stored token).
 *
 * - requestAdminPasswordReset: the "forgot password" form. ant stores the
 *   one-time token and emails the reset link; the answer is `true` whether or
 *   not the address belongs to an admin, so it reveals nothing. Replaces the
 *   legacy REST `POST /adminuser/resetpassword`. The link still lands on the
 *   set-password page, which consumes the token through the legacy API.
 *
 * Note: Run `npm run relay` after editing GraphQL queries to regenerate type
 * artifacts under __generated__.
 */

import { commitMutation } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';
import { relayEnvironment } from '../../../relay';
import type { MutationResult } from '../../admins/mutation/V2/useAdminMutations';

const RequestAdminPasswordResetMutation = graphql`
  mutation useAuthMutationsRequestAdminPasswordResetMutation(
    $input: RequestAdminPasswordResetInput!
  ) {
    requestAdminPasswordReset(input: $input)
  }
`;

export function requestAdminPasswordResetMutation(
  email: string
): Promise<MutationResult<boolean>> {
  return new Promise((resolve) => {
    commitMutation<any>(relayEnvironment, {
      mutation: RequestAdminPasswordResetMutation,
      variables: { input: { email } },
      onCompleted: (response: any, errors) => {
        const result = response?.requestAdminPasswordReset ?? null;
        const gqlErrors = (errors ?? []).map((e) => ({ message: e.message }));
        resolve({
          data: result,
          errors: gqlErrors,
          isSuccess: gqlErrors.length === 0 && result === true,
        });
      },
      onError: (error: Error) => {
        resolve({
          data: null,
          errors: [{ message: error.message }],
          isSuccess: false,
        });
      },
    });
  });
}
